// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"888":"cdb95162","2209":"70d481b7","3298":"70d481b7"}[chunkId] + ".chunk.css";
};